import { observer } from "mobx-react-lite";
import Icon from "@mdi/react";
import { mdiHistory } from "@mdi/js";
import type { FeedbackTimelineEventDto } from "@pro-sto/api-client";
import { feedbackStore } from "@/stores/FeedbackStore";
import {
  formatStatusChangeLabel,
  formatTimelineDate,
} from "./constants";

function TimelineEventItem({
  event,
}: {
  event: FeedbackTimelineEventDto;
}) {
  const author = event.author_name ?? "Администратор";
  const isComment = event.type === "comment";

  return (
    <li
      className={`fb-timeline__item ${
        isComment ? "fb-timeline__item--comment" : "fb-timeline__item--status"
      }`}
    >
      <div className="fb-timeline__marker" aria-hidden="true" />
      <div className="fb-timeline__content">
        <div className="fb-timeline__meta">
          <span className="fb-timeline__author">{author}</span>
          <span className="fb-timeline__date">
            {formatTimelineDate(event.created_at)}
          </span>
        </div>
        {isComment ? (
          <p className="fb-timeline__comment-text">{event.text}</p>
        ) : (
          <p className="fb-timeline__status-text">
            {formatStatusChangeLabel(event.old_status, event.new_status)}
          </p>
        )}
      </div>
    </li>
  );
}

const FeedbackTimeline: React.FC = observer(() => {
  const { selectedFeedback, isDetailLoading } = feedbackStore;

  if (isDetailLoading || !selectedFeedback) return null;

  const timeline = selectedFeedback.timeline ?? [];

  return (
    <section
      className="fb-drawer-section fb-drawer-section--timeline"
      data-testid="feedback-drawer-timeline"
    >
      <div className="fb-drawer-timeline__header">
        <Icon path={mdiHistory} size={0.75} />
        <span className="fb-drawer-section__title">История и комментарии</span>
      </div>

      {timeline.length === 0 ? (
        <p className="fb-timeline__empty">Пока нет событий</p>
      ) : (
        <ul className="fb-timeline">
          {timeline.map((event) => (
            <TimelineEventItem key={event.uuid} event={event} />
          ))}
        </ul>
      )}
    </section>
  );
});

FeedbackTimeline.displayName = "FeedbackTimeline";
export default FeedbackTimeline;
